/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import baseApi from '@features/base/BaseSlice';
import {
  DomainsApiProps, StoreParamsProps, StoreSectionApiProps, StoreSendEmailParamsProps,
} from './types';
import domain from './domain';

const domainTag = baseApi.enhanceEndpoints({ addTagTypes: [domain.tagType] });
const domainApi = domainTag.injectEndpoints({
  endpoints: (builder) => ({
    getSectionsByDomain: builder.query<DomainsApiProps, StoreParamsProps>(domain.getStoresDomain()),
    addDomainSection: builder.mutation<StoreSectionApiProps, Partial<StoreSectionApiProps>>(domain.addDomain()),
    sendEmailDomain: builder.mutation<void, StoreSendEmailParamsProps>(
      domain.sendEmail(),
    ),
  }),
  overrideExisting: false,
});

export const {
  useGetSectionsByDomainQuery,
  useAddDomainSectionMutation,
  useSendEmailDomainMutation,
} = domainApi;
